import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const Whychooseusa = () => {
  return (
    <div className="whychooseusa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Why Choose Us</span> as Your Trusted Healthcare Software
              Development Company?
            </h2>
          </Col>
        </Row>
        <Row className="h-100 choose_padd">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <p>
              Curious about what sets us apart in strategic collaboration? It is
              our ability to convert healthcare concepts into strong software
              solutions. Here's why you should choose us as your top healthcare
              software development partner:
            </p>

            <ul>
              <li>
                <strong>Expertise & Experience:</strong> We use agile techniques
                and transparent communication for real-time insights, nurturing
                collaborative development engagement.
              </li>
              <li>
                <strong>Communication:</strong> We use agile techniques and
                transparent communication for real-time insights, fostering
                collaborative development engagement.
              </li>
              <li>
                <strong>Scalability:</strong> We provide healthcare software
                with adaptable designs, embracing cloud technology for easy
                growth while guaranteeing alignment with operational demands.
              </li>
              <li>
                <strong>Technical Proficiency:</strong> Our developers excel in
                the latest frameworks, showcasing technical mastery for complex
                healthcare projects.
              </li>
              <li>
                <strong>Cost-Effectiveness:</strong> We maximize efficiency
                through coding and agile workflows, ensuring cost-effectiveness
                without compromising software quality.
              </li>
            </ul>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7}>
            <StaticImage
              src="../../images/services-usa/healthcare-software/why-choose.webp"
              alt="Healthcare Software Development Company"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={993}
              height={832}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whychooseusa;
